/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component} from '@angular/core';
import {ExplorationComponent} from '../common/directives/exploration.component';

@Component({
  standalone: true,
  selector: 'adn-explore-page',
  imports: [ExplorationComponent],
  template: '<adn-exploration-component [networkWide]="true" [suppressAdUnitBreakdown]="true"></adn-exploration-component>'
})
export class ExplorePageComponent {
}
